const hu = {
   
    message: {
        title1: 'Távoli vezérlés okos otthonokhoz, technológia, biztonság és kényelem',
        content1: 'Az AigoSmart segít az otthoni okoseszközök távoli kezelésében és vezérlésében. Az eszközök kölcsönösen érzékelik és reagálnak egymásra, egyetlen gombnyomással az otthoni különböző eszközök beállíthatók a már előre meghatározott állapotba, biztonságos és gondtalan okos otthoni életet teremtve.',
        title2: "Az AigoSmart az Aigostar vadonatúj almárkája",
        content2: "A termékek jelenleg az Európai országokba és régiókba kerülnek értékesítésre, mint például Spanyolország, Portugália, Franciaország, Olaszország, Hollandia, Németország, Finnország, Dánia, Lengyelország, Oroszország, Görögország, Ausztria, Svájc, Csehország, Magyarország, Szlovákia stb.",
        content3: "Az AIGOSTAR számos konyhai és vasalási kis háztartási készüléke folyamatosan az eladási lista első tíz helyén található.",
        content4: "Az eladási rangsorban az első tíz helyen.",
        title3: "Márkadijak",
        content5: "Gyors. Nyitott. Innovatív. Kitartó.",
        loading: 'Betöltés',
        submit: 'Küldés',
        contactUs: "Kapcsolat",
        privacy: "Adatvédelmi irányelvek",
        policy: "Szolgáltatási irányelvek",
        download: "Letöltés",
    },
    
    wisdomleads: {
        title1: 'Távoli vezérlés okos otthonokhoz, technológia, biztonság és kényelem',
        content1: 'A wisdomleads segít az otthoni okoseszközök távoli kezelésében és vezérlésében. Az eszközök kölcsönösen érzékelik és reagálnak egymásra, egyetlen gombnyomással az otthoni különböző eszközök beállíthatók a már előre meghatározott állapotba, biztonságos és gondtalan okos otthoni életet teremtve.',
        title2: "A wisdomleads az Aigostar vadonatúj almárkája",
        content2: "A termékek jelenleg az Európai országokba és régiókba kerülnek értékesítésre, mint például Spanyolország, Portugália, Franciaország, Olaszország, Hollandia, Németország, Finnország, Dánia, Lengyelország, Oroszország, Görögország, Ausztria, Svájc, Csehország, Magyarország, Szlovákia stb.",
        content3: "A wisdomleads számos konyhai és vasalási kis háztartási készüléke folyamatosan az eladási lista első tíz helyén található.",
        content4: "Az eladási rangsorban az első tíz helyen.",
        title3: "Márkadijak",
        content5: "Gyors. Nyitott. Innovatív. Kitartó.",
        loading: 'Betöltés',
        submit: 'Küldés',
        contactUs: "Kapcsolat",
        privacy: "Adatvédelmi irányelvek",
        policy: "Szolgáltatási irányelvek",
        download: "Letöltés",
    },
    

    v119: {
        password: "Jelszó",
        back: "Vissza",
        account: 'Fiókszám megadása',
        VerifyAccount: "Fiók ellenőrzése",
        confire: "Megerősítés",
        complete: "Befejezés",
        loginAccount: "Fiók bejelentkezése",
        VerifyCode: "Ellenőrző kód",
        preview: "Előző",
        next: "Következő",
        enterEmail: "Adja meg az e-mail címét",
        phone: "Mobil bejelentkezés",
        email: "E-mail bejelentkezés",
        pleaseenter: "Kérem, adja meg",
        emailError: "Hibás e-mail formátum",
        phoneError: "Hibás telefonszám formátum",
        qcCodeError: "Ellenőrző kód hibás",
        sendCode: "Ellenőrző kód küldése",
        reSend: "Újraküldés",
        tip1: "A fiók és vagyonbiztonság biztosítása érdekében az alábbi információkat ellenőrizzük a fiók lemondása előtt:",
        tip2: "A fiók biztonságos állapotban van",
        tip3: "Az utolsó 15 napban nem voltak érzékeny műveletek, mint a mobil/e-mail kötés, jelszóváltoztatás, belépési eszköz csere, stb.",
        tip4: "A fiók nem üzemelteti az intelligens eszközöket",
        tip5: "Ön kijelentkezett (vagy nincs hozzárendelve) az intelligens eszközökhöz",
        tip6: "Nincs vagyonkockázat a fiókon",
        tip7: "Az utolsó 15 napban nem voltak érzékeny műveletek, mint jelszóváltoztatás, vásárlási rekordok, bankkártya kötés, stb.",
        accountCancellation: "Fiók lemondása",
        tip8: "Köszönjük az eddigi támogatását. Sajnáljuk, hogy az AigoSmart nem tudja folytatni a szolgáltatást Önnek. A fiók lemondása előtt újra ellenőrizzük a fiókját. Kérjük, vegye figyelembe, hogy a lemondás sikeresen történt, az alábbi információk véglegesen törlésre kerülnek.",
        tip9: "Köszönjük az eddigi támogatását. Sajnáljuk, hogy a Wisdomleads nem tudja folytatni a szolgáltatást Önnek. A fiók lemondása előtt újra ellenőrizzük a fiókját. Kérjük, vegye figyelembe, hogy a lemondás sikeresen történt, az alábbi információk véglegesen törlésre kerülnek.",
        tip10: "1. Az intelligens modulok, szobák, otthonok, eszközök hálózati információi véglegesen törlésre kerülnek és nem lehet visszaállítani",
        tip11: "2. A jelenetek, automatizálások, egyéni receptek stb. információi véglegesen törlésre kerülnek és nem lehet visszaállítani",
        tip13: "3. Az összes fiókinformáció, szolgáltatási rekord, fogyasztási információ stb. véglegesen törlésre kerül és nem lehet visszaállítani",
        tip14: "4. Nem tud bejelentkezni és használni az AigoSmart fiókját. Családtagjai/barátai nem tudnak eszközöket megosztani az Ön fiókján keresztül",
        tip14w: "4. Nem tud bejelentkezni és használni a Wisdomleads fiókját. Családtagjai/barátai nem tudnak eszközöket megosztani az Ön fiókján keresztül",
        tip15: "5. Az AigoSmart fiókjának személyes adatai és történelmi üzenetei (beleértve a profilképet, becenevet, eszközriasztásokat, platform-értesítéseket, otthoni üzeneteket stb.) vissza nem állíthatók",
        tip15w: "5. A Wisdomleads fiókjának személyes adatai és történelmi üzenetei (beleértve a profilképet, becenevet, eszközriasztásokat, platform-értesítéseket, otthoni üzeneteket stb.) vissza nem állíthatók",
        tip16: "6. A fiókon lévő pénzügyi eszközöket (pontok, tagsági szint, jogosultságok, rendelések, kuponok, eszközök és egyéb értékes szolgáltatások) gondoskodni kell az fiók lemondása előtt. A fiók lemondása azt jelenti, hogy Ön önként lemond és nem folytathatja a szolgáltatásokat. Megérti és elfogadja, hogy az AigoSmart nem tud segíteni az előző szolgáltatások helyreállításában",
        tip16w: "6. A fiókon lévő pénzügyi eszközöket (pontok, tagsági szint, jogosultságok, rendelések, kuponok, eszközök és egyéb értékes szolgáltatások) gondoskodni kell az fiók lemondása előtt. A fiók lemondása azt jelenti, hogy",
        tip17: "A platform 15 napon belül feldolgozza a kérelmét és törli az összes adatát. Kérjük, az utolsó 15 napban ne lépjen be a platformra, hogy biztosítsa a lemondás sikeres befejezését",
        tip18: "Kérem, adja meg az ellenőrző kódot",
        tip12: "Jelenleg nem mondhat le",
        tip20: "Az platformmal kapcsolatos javaslatok (nem kötelező)",
        errorMsg1: "Felhasználó nem létezik",
        errorMsg2: "A felhasználó már kérelmezte a lemondást",
        errorMsg3: "A felhasználó az utolsó 15 napban érzékeny műveleteket hajtott végre, például jelszóváltoztatás, eszközcsere, stb. Ezért a lemondás tiltott",
        errorMsg4: "Hibás ellenőrző kód",
        tip21: "Kérjük, várjon, az emberi ellenőrzés folyamatban van",
    }
    
   
    
}

export default hu;